export default "__VITE_ASSET__Dvx9ps0Z__"